enum ShipmentBuilderStep {
  READY = 0,
  PREVIEW = 1,
  BUILDING = 2,
  COMPLETED = 3,
}

export default ShipmentBuilderStep;
